import { render, staticRenderFns } from "./CompanyAlbum.vue?vue&type=template&id=516905c3&scoped=true"
import script from "./CompanyAlbum.vue?vue&type=script&lang=js"
export * from "./CompanyAlbum.vue?vue&type=script&lang=js"
import style0 from "./CompanyAlbum.vue?vue&type=style&index=0&id=516905c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516905c3",
  null
  
)

export default component.exports